import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
    const brandedCtaSection = document.querySelectorAll('.branded-cta-section');

    brandedCtaSection.forEach(section => {

        // ✅ Scope everything to THIS section
        const tabs = section.querySelectorAll('.bcs-tab-item');
        const imgSlider = section.querySelector('.bcs-img-slider');
        const contentSlider = section.querySelector('.bcs-content-slider');

        // ✅ Controls (IMPORTANT)
        const nextBtn = section.querySelector('.bcs-button-next');
        const prevBtn = section.querySelector('.bcs-button-prev');
        const pagination = section.querySelector('.bcs-pagination');

        // Init Image Swiper
        const imgSwiper = new Swiper(imgSlider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: false,
        });

        // Init Content Swiper (with controls)
        const contentSwiper = new Swiper(contentSlider, {
            slidesPerView: 1,
            autoHeight: true,
            allowTouchMove: true,
            spaceBetween: 16,

            // ✅ ADD CONTROLS HERE
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
        });

        // Tab click handler
        tabs.forEach((tab) => {
            tab.addEventListener('click', function() {
                const target = this.getAttribute('data-tab');

                tabs.forEach(t => t.classList.remove('is-active'));
                this.classList.add('is-active');

                const slides = section.querySelectorAll('.bcs-content-item');

                let targetIndex = 0;
                slides.forEach((slide, i) => {
                    if (slide.getAttribute('data-id') === target) {
                        targetIndex = i;
                    }
                });

                imgSwiper.slideTo(targetIndex);
                contentSwiper.slideTo(targetIndex);
            });
        });

        // ✅ Sync tab active state when using arrows/pagination
        contentSwiper.on('slideChange', function() {
            const activeIndex = contentSwiper.activeIndex;

            tabs.forEach(t => t.classList.remove('is-active'));
            if (tabs[activeIndex]) {
                tabs[activeIndex].classList.add('is-active');
            }

            imgSwiper.slideTo(activeIndex);
        });

    });
});